/**
 * formatBytes(1200) -> '1.2 KB'
 * formatBytes(3 500 000) -> '3.5 MB'
 * @param bytes
 * @param decimals
 */
export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const kilobyte = 1000
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const sizesIndex = Math.floor(Math.log(bytes) / Math.log(kilobyte))

  return `${parseFloat((bytes / kilobyte ** sizesIndex).toFixed(dm))} ${
    sizes[sizesIndex]
  }`
}
